/*
 * Submits any form.klaviyo-signup-form to the Klaviyo client subscriptions API.
 * Shared by the product email signup block and the custom button's Notify me
 * form. The form carries data-company-id, data-list-id, data-source and
 * data-signup-intent; on success the [data-signup-fields] wrapper (or the
 * newsletter field) is hidden and the success message shown.
 */
(function () {
  if (window.klaviyoSignupInit) return;
  window.klaviyoSignupInit = true;

  function showError(form, text) {
    var error = form.querySelector('.form__message--error');
    error.querySelector('[data-message-text]').textContent = text;
    error.hidden = false;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains('klaviyo-signup-form')) return;
    event.preventDefault();

    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var success = form.querySelector('.form__message--success');
    var fields = form.querySelector('[data-signup-fields]') || form.querySelector('.field--newsletter');
    form.querySelector('.form__message--error').hidden = true;

    if (!input.value || !input.checkValidity()) {
      showError(form, input.validationMessage || 'Please enter a valid email address.');
      return;
    }

    button.setAttribute('disabled', '');
    button.setAttribute('aria-busy', 'true');

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.dataset.source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: input.value.trim(),
                properties: {
                  signup_intent: form.dataset.signupIntent,
                },
              },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: form.dataset.listId } },
        },
      },
    };

    fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-10-15',
        },
        body: JSON.stringify(payload),
      }
    )
      .then(function (response) {
        if (response.ok) {
          fields.hidden = true;
          success.hidden = false;
          success.focus();
          return;
        }
        return response
          .json()
          .catch(function () {
            return null;
          })
          .then(function (body) {
            var text = 'Something went wrong. Please try again.';
            if (body && body.errors && body.errors[0] && body.errors[0].detail) {
              text = body.errors[0].detail;
            }
            showError(form, text);
          });
      })
      .catch(function () {
        showError(form, 'Could not connect. Please check your connection and try again.');
      })
      .then(function () {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-busy');
      });
  });
})();
